import type { UUID } from '@/utils/uuid';

export const tenantQueryKeys = {
  lists: () => ['tenants'] as const,
  list: (limit?: number, filter?: string) =>
    ['tenants', limit ?? null, filter ?? null] as const,
  joinableList: (limit?: number, filter?: string) =>
    ['joinable-tenants', limit ?? null, filter ?? null] as const,
  detail: (tenantId?: UUID) => ['tenant', tenantId] as const,
  current: (slug?: string) => ['tenant', 'current', slug] as const,
  has: () => ['tenants', 'has'] as const,
  slug: (slug?: string) => ['slug', slug] as const,
  slugAvailability: (slug?: string | null) =>
    ['tenant-slug-available', slug] as const,
};
